import { Route, Routes } from 'react-router-dom';
import ProfileNavigate from 'components/ProfileNavigate';
import Plaid from './Plaid';

const Transaction: React.FC = () => {
    return (
        <Routes>
            <Route path="plaid/*" element={<Plaid />} />
            <Route path="*" element={<ProfileNavigate to="/profile" replace />} />
        </Routes>
    );
};

export default Transaction;
